export default __webpack_public_path__ + "assets/865c119be7728c9f4fb803667146a40e.svg";